<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="10" class="mb-4">
        <div class="w-100 text-center">
          <div class="clearfix">            
            <div>
              <img
                src="/./img/site_logo.png"
                width="211"
                
                v-show="this.$i18n.locale != 'en'"
              />
              <img
                src="/./img/site_logo_en.png"
                width="211"
                
                v-show="this.$i18n.locale == 'en'"
              />
            </div>
            <br>
            <p v-html="$t('本HPのご利用前に、以下利用規約（アンカーリンク）をご確認ください。')">
            <p>{{ $t('ご利用開始した時点で利用規約に同意したものとみなします。') }}</p>
            <p>{{ $t('本HP「おみせのトラスト」は、お店のトラスト情報（信頼性情報）を見える化する実証実験です。') }}
              <br>{{ $t('ここでいうトラスト情報とは、以下にあるコロナ対策を実施してるかを証明し、 確認できるようにすることを目的としています。') }}</p>
          </div>
        </div>
      </CCol>
      <CCol md="4" class="mb-4 text-left">
        <CButton col="4" color="success" block @click="agreeRule">{{ $t('利用規約に同意し、ユーザー登録へ進む。') }}</CButton>
      </CCol>
      <CCol md="12" id="termOfService">
        <CCard>
          <CCardHeader><h3 class="mb-0">{{ $t('利用規約') }}</h3></CCardHeader>
          <CCardBody>
            <div class="overflow-auto" style="height: 15rem;">
              <p v-t="'shops'" style="white-space: pre-line;" />
              <!-- <p>{{terms1}}</p>
              <p>{{terms2}}</p>
              <p>{{terms3}}</p>
              <h3>{{terms4}}</h3>
              <h3>{{terms5}}</h3>
              <p>{{terms6}}</p>
              <p>{{terms7}}</p>
              <p>{{terms8}}</p>
              <h3>{{terms9}}</h3>
              <p>{{terms10}}</p>
              <p>{{terms11}}</p>
              <p>{{terms12}}</p>
              <h3>{{terms13}}</h3>
              <h3>{{terms14}}</h3>
              <p>{{terms15}}</p>
              <p>{{terms16}}</p>
              <p>{{terms17}}</p>
              <p>{{terms18}}</p>
              <p>{{terms19}}</p>
              <p>{{terms20}}</p>
              <h3>{{terms21}}</h3>
              <h3>{{terms22}}</h3>
              <p>{{terms23}}</p>
              <p>{{terms24}}</p>
              <p>{{terms25}}</p>
              <p>{{terms26}}</p>
              <p>{{terms27}}</p>
              <p>{{terms28}}</p>
              <p>{{terms29}}</p>
              <p>{{terms30}}</p>
              <p>{{terms31}}</p>
              <p>{{terms32}}</p>
              <h3>{{terms33}}</h3>
              <p>{{terms34}}</p> -->
            <!-- <div>
              <img class="mw-100" src="/./img/terms.png" />
            </div> -->
            <div v-if="this.$i18n.locale == 'ja'">
              <img class="sp" src="/img/terms.png" />
            </div>
            <div v-if="this.$i18n.locale == 'en'">
              <img class="sp" src="/img/terms_en.png" />
            </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { messages } from '@/assets/lang/terms'
export default {
  name: 'Rule',
  i18n: {
    messages,
  },
  data () {
    return {
      // terms1: 'この利用規約は、本「おみせのトラスト」の利用条件を記載したものです。「おみせのトラスト」とは、登録者が飲食店等における感染症対策に関する情報を本「おみせのトラスト」に登録し、利用者が本「おみせのトラスト」から情報を取得できるようにするサービスをいいます。',
      // terms2: '本「おみせのトラスト」は、(株)日立製作所が実証実験の推進目的に運営します。この実証を通じて、社会におけるデジタル技術を利用した「信頼」という考え方の理解を深めるとともに、関係者の経済活動の維持や、利用者が安心して飲食店を利用できる環境づくりを目指しています。',
      // terms3: '本「おみせのトラスト」は、この目的に賛同し、利用規約に同意し、遵守していただける方であればどなたでもお使いいただけます。',
      // terms4: '１．利用者向け',
      // terms5: '１－１．許可',
      // terms6: '本「おみせのトラスト」の著作権は(株)日立製作所に帰属し、(株)日立製作所は利用者による以下のような情報利用を認め異議を述べません。',
      // terms7: '・利用者が本「おみせのトラスト」で提供する情報を、利用者の名で、一部の複製、変更、翻案、公衆送信し、利用者のアイコンとして使用することを含め任意の方法で二次利用を行うこと',
      // terms8: '・本「おみせのトラスト」の各コンテンツのページに直接リンクを張ること',
      // terms9: '１－２．禁止',
      // terms10: '本「おみせのトラスト」の利用者は以下のことを行わないで下さい。(株)日立製作所は、これを行った利用者に対しては、利用の差し止め、損害賠償を求め、(株)日立製作所が何らの警告なく掲載情報を削除することがあります。利用者はこの措置による損害の賠償を求めることはできません。また、利用者は、この措置に対し、(株)日立製作所に対して、異議を述べ、抗弁することはできません。',
      // terms11: '・利用者が本「おみせのトラスト」から取得した情報を他の利用者に提供するときに、他の利用者からの誤解を招く表現を用いること',
      // terms12: '・利用者が本「おみせのトラスト」から取得した情報を用いて、本「おみせのトラスト」の偽サイトを作成すること',
      // terms13: '２．登録者向け',
      // terms14: '２－１．保証',
      // terms15: '登録者は本「おみせのトラスト」に情報を登録するときは、以下のことを守り、情報の内容について責任を持ってください。',
      // terms16: '・公序良俗、真実性、適法性について責任をもってデータを入力すること',
      // terms17: '・登録情報の内容に変更があった場合は、速やかに情報を更新すること',
      // terms18: '・入力したデータ、情報の著作権を(株)日立製作所に譲渡し、(株)日立製作所が第三者への提供を承諾すること',
      // terms19: '・入力したデータや情報が他社の著作権などを侵害しないこと',
      // terms20: '・個人情報関連法律やプライバシ等のガイドラインに従い情報の登録を行うこと',
      // terms21: '３．免責',
      // terms22: '３－１．免責',
      // terms23: '本「おみせのトラスト」は(株)日立製作所が行う実証実験の目的にご賛同いただきご参加いただくものです。従って、(株)日立製作所は、利用者・登録者が、本「おみせのトラスト」をご利用になることをもって、以下の負担に同意したものと看做します。',
      // terms24: '①本「おみせのトラスト」は、利用者・登録者ご自身の責任で御利用いただきます。',
      // terms25: '②(株)日立製作所は、本「おみせのトラスト」の稼働・継続を保証しません。',
      // terms26: '③(株)日立製作所は、本「おみせのトラスト」の拡張や利便性向上のために行う登録情報や提供情報のアップデートを行うことがあります。',
      // terms27: '④(株)日立製作所は、目的に照らして不適切と判断した内容を本「おみせのトラスト」の管理者により削除し又は非表示にすることがあります。',
      // terms28: '⑤(株)日立製作所は、その都合により、本「おみせのトラスト」運営を中止し、第三者にその地位及び権利を譲渡することがあります。',
      // terms29: '⑥(株)日立製作所は、利用者・登録者または第三者が本「おみせのサービス」を利用することによりいかなる損害を受け、または不利益を蒙っても、その責任を負いません。',
      // terms30: '⑦利用者・登録者が本「おみせのサービス」を利用したことにより、(株)日立製作所が第三者から責任の追及を受けたときは、利用者・登録者が連帯して(株)日立製作所に代わって第三者の全ての損害を直ちに賠償しなければなりません。各利用者・登録者の負担分は均等とします。',
      // terms31: '⑧本「おみせのトラスト」が提供する情報の内容に対する責任は登録者にあり、(株)日立製作所は関与しませんので、クレームへの対応は登録者が行ってください。',
      // terms32: '⑨(株)日立製作所は、利用者・登録者が本項に定める負担を負うことができないと認めたときは、何らの予告をせず、その損賠を賠償することなく、本「おみせのトラスト」の利用をお断りすることができます。利用者・登録者はこれに異議を唱えることはできません。',
      // terms33: '３－２．サイト運営',
      // terms34: '(株)日立製作所は本「おみせのトラスト」の運営について、登録者の許諾なく以下を実施します。登録者はこれらに合意したうえで本「おみせのトラスト」を利用するものと看做します。'
    }
  },
  methods: {
    agreeRule(){
      this.$router.push("/pages/register");
    },
  },
}
</script>
